const BASE_TITLE = 'Addsome Backoffice'

export function updatePageTitle(page?: string) {
  document.title = BASE_TITLE + (page ? ` - ${page}` : '')
}

export function replacePageTitle(title: string) {
  document.title = title;
}
